import Layout from "Layout";
import {
  BanerProfile,
  ProfileContainer,
  CardForm,
  BadgeNotification,
} from "./styled.components";
import { useSelector, useDispatch } from "react-redux";
import CatalogsModal from "Components/CatalogsModal";
//import "assets/css/profile/index.css"
import Cropper from "react-cropper";
import React from "react";
import { update as updateUser } from "actions/user";
import { getIconForProfile, hotToast } from "utils";
const Profile = () => {
  const { bannerProfile, background, iconsProfile } = useSelector(
    (state: any) => state.theme
  );
  const {
    fullName,
    email,
    perfil,
    idUsuario,
    idMarcaOrigen,
    imagen,
    idTipoOperOrigen,
    marcaOrigen,
    tipoOperOrigen,
  } = useSelector((state: any) => state.user);
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [photo, setPhoto] = React.useState<File | null>();
  const [cropper, setCropper] = React.useState<any>();
  const [image, setImage] = React.useState<string>("");
  const [loader, setLoader] = React.useState<boolean>(false);

  const dispatch = useDispatch();
  const { PUBLIC_URL } = process.env;

  React.useEffect(() => {
    setOpenModal(photo ? true : false);
    if (photo) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result as any);
      };
      reader.readAsDataURL(photo);
    }
  }, [photo]);

  const handleSave = () => {
    if (typeof cropper !== "undefined") {
      fetch(cropper.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "photo.png", { type: "image/png" });
          setLoader(true);
          let _form = new FormData();
          _form.append("photo", file);
          _form.append("idUsuario", idUsuario);
          _form.append("idMarcaOrigen", idMarcaOrigen);
          if (idTipoOperOrigen) {
            _form.append("idTipoOperOrigen", idTipoOperOrigen);
          }
          _form.append("idEstatus", "true");

          updateUser(_form).then((res) => {
            if (res) {
              if (res.imagen)
                dispatch({
                  type: "SET_IMAGEN",
                  payload: res.imagen,
                });
            }
            setLoader(false);
            setOpenModal(false);
          });
        });
    }
  };

  return (
    <Layout
      theme={{
        backgroundColor: background,
      }}
    >
      <ProfileContainer>
        <BanerProfile
          bgImagen={
            bannerProfile
              ? `${PUBLIC_URL}${bannerProfile}`
              : "/commons/bg_profile_2.png)"
          }
        >
          <div className={"container-profile"}>
            <div className={"controls"}>
              <img
                className={"photo"}
                alt="#"
                src={imagen ? imagen : `${PUBLIC_URL}/avatars/default.png`}
              />
              <label className={"control-file"} htmlFor={"photo"}>
                <img
                  src={`${PUBLIC_URL}/commons/camara-fotografica.svg`}
                  alt="#"
                />
              </label>
              <input
                type={"file"}
                hidden
                id={"photo"}
                accept={"png, jpg, jpng"}
                onChange={(val) => {
                  if (val) {
                    let rgx = /\.(gif|jpe?g|png)$/i;
                    //@ts-ignore
                    let match = val.target.files[0].name.match(rgx);
                    if (match === null) {
                      hotToast("El archivo no es una imagen valida", "ERROR");
                      return false;
                    }
                  }
                  setPhoto(val.target.files ? val.target.files[0] : null);
                }}
              />
            </div>
          </div>
          <div className={"container-name"}>
            <h1 className={"title-user"}>{fullName}</h1>
          </div>
        </BanerProfile>
        {/*
 <BadgeNotification>
          <span className={"title"}>Notificaciones</span>
          <span className={"count"}>106</span>
        </BadgeNotification>
         */}
        <CardForm>
          <div className={"line-card"}>
            <span>Información</span>
          </div>
          <div className={"card-form-items"}>
            <div className={"item-control"}>
              <div className={"control-label"}>
                <img
                  alt={"#"}
                  src={getIconForProfile({
                    key: "name",
                    source: iconsProfile,
                    icon: "commons/ic_account_circle_24px.svg",
                  })}
                />
                <label>Nombre</label>
              </div>
              <div className={"control-value"}>
                <span>{fullName}</span>
              </div>
            </div>
            <div className={"item-control"}>
              <div className={"control-label"}>
                <img
                  alt={"#"}
                  src={getIconForProfile({
                    key: "email",
                    source: iconsProfile,
                    icon: "commons/nuevo-sobre-de-correo-electronico.svg",
                  })}
                />
                <label>Correo</label>
              </div>
              <div className={"control-value"}>
                <span>{email}</span>
              </div>
            </div>
            <div className={"item-control"}>
              <div className={"control-label"}>
                <img
                  alt={"#"}
                  src={getIconForProfile({
                    key: "profile",
                    source: iconsProfile,
                    icon: "commons/grupo.svg",
                  })}
                />
                <label>Perfil</label>
              </div>
              <div className={"control-value"}>
                <span className={"tag color-blue"}>{perfil}</span>
              </div>
            </div>
            <div className={"item-control"}>
              <div className={"control-label"}>
                <img
                  alt={"#"}
                  src={getIconForProfile({
                    key: "operacion",
                    source: iconsProfile,
                    icon: "commons/proyecto.svg",
                  })}
                />
                <label>Marca y Operación</label>
              </div>
              <div className={"control-value"}>
                <span className={"tag color-verde"}>{marcaOrigen}</span>
                <span className={"tag color-verde"}>{tipoOperOrigen}</span>
              </div>
            </div>
          </div>
        </CardForm>
        {openModal && (
          <CatalogsModal
            title="Imagen"
            open={openModal}
            modalSize={"md"}
            handleAcceptClick={handleSave}
            isLoading={loader}
            handleCancelClick={() => {
              setOpenModal(false);
            }}
          >
            {image && (
              <Cropper
                style={{ height: 320, width: "100%" }}
                zoomTo={0.5}
                initialAspectRatio={1}
                preview=".img-preview"
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                onInitialized={(instance) => {
                  setCropper(instance);
                }}
                guides={true}
              />
            )}
          </CatalogsModal>
        )}
      </ProfileContainer>
    </Layout>
  );
};

export default Profile;
